<template>
  <div class="col-lg-4 col-md-6 col-12" >
    <div class="pb-0 card-header">
      <div class="d-lg-flex">
        <i class="fa-solid fa-address-card icon-primary mt-2"></i><h6 class="ms-2 mb-3">{{ $t('key_returnCustomerInfo_customerInformation') }}</h6>
      </div>
    </div>
    <div class="pb-0 card-body">
      <ul v-if="!!orderBack" class="list-group">
        <li class="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg">
          <div class="d-flex flex-column">
            <h6 class="mb-3 text-sm text-primary">{{ orderBack.end_customer.name }}</h6>
            <span class="mb-2 text-xs">
              {{ $t('key_returnCustomerInfo_customerName') }}:
              <span class="text-primary ms-2 font-weight-bold">{{ orderBack.end_customer.contact }}</span>
            </span>
            <span class="mb-2 text-xs">
              {{ $t('key_returnCustomerInfo_customerVatNumber') }}:
              <span class="text-primary ms-2 font-weight-bold">{{ orderBack.end_customer.vat }}</span>
            </span>
            <span class="mb-2 text-xs">
              {{ $t('key_returnCustomerInfo_customerAddress') }}:
              <span class="text-primary font-weight-bold ms-2">
                <a class="text-primary" :href="`https://www.google.com/maps?q=${encodeURIComponent(getFullAddress(orderBack.end_customer.address))}`" target="_blank">
                  {{ getFullAddress(orderBack.end_customer.address) }}
                </a>
              </span>
            </span>
            <span class="mb-2 text-xs">
              {{ $t('key_returnCustomerInfo_customerPhone') }}:
              <span class="text-primary ms-2 font-weight-bold">
                <a class="text-primary" :href="`tel:${orderBack.end_customer.phone}`">
                  {{ orderBack.end_customer.phone }}
                </a>
              </span>
            </span>
            <span class="text-xs">
              {{ $t('key_returnCustomerInfo_customerEmail') }}:
              <span class="text-primary ms-2 font-weight-bold">
                <a class="text-primary" :href="`mailto:${orderBack.end_customer.email}`">
                  {{ orderBack.end_customer.email }}
                </a>
              </span>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="pb-0 card-footer" />
  </div>
</template>

<script>

export default {
  name: "OrderBackCustomerInfo",
  components: {
  },
  props: {
    orderBack: {
      type: Object,
      default: null,
    },
  },  
  data() {
    return {};
  },
  methods: {
    getFullAddress(address) {
      return (address.street + " " + address.postal_code + " " + address.town + " " + address.province + " " + address.country);
    }
  }
};

</script>

<style>

  .icon-primary {
    color: #4A7062 !important;
  }

</style>